var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticClass:"scroll-to-top",on:{"click":function($event){return _vm.doScroll()}}},[(_vm.featureSet.scrollToTop.arrow)?_c('fa-icon',{attrs:{"icon":"arrow-up"}}):_c('fa-icon',{attrs:{"icon":"angle-double-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }